import { COLORS } from "./colors";

export enum SellingStage {
  FIRST_CONTRACT = "Перший контракт",
  NEGOTIATION = "Перемовини",
  ON_HOLD = "На паузі",
  PRICE_OFFER = "Цінова пропозиція",
  IMPLEMENTATION = "Реалізація",
  LOST_DEAL = "Втрачена угода",
  CLOSED_DEAL = "Завершена угода",
}

export interface SellingStyle {
    txtColor: string;
    bgColor: string;
}

export const sellingStagesObj: Record<SellingStage, SellingStyle> = {
  [SellingStage.FIRST_CONTRACT]: {
    txtColor: COLORS.blue,
    bgColor: COLORS["light-blue"],
  },
  [SellingStage.PRICE_OFFER]: {
    txtColor: COLORS.blue,
    bgColor: COLORS["light-blue"],
  },
  [SellingStage.NEGOTIATION]: {
    txtColor: COLORS.warning,
    bgColor: COLORS["light-warning"],
  },
  [SellingStage.IMPLEMENTATION]: {
    txtColor: COLORS.main2,
    bgColor: COLORS["light-orange"],
  },
  [SellingStage.CLOSED_DEAL]: {
    txtColor: COLORS.main1,
    bgColor: COLORS["light-green"],
  },
  [SellingStage.LOST_DEAL]: {
    txtColor: COLORS.warning,
    bgColor: COLORS["light-warning"],
  },
  [SellingStage.ON_HOLD]: {
    txtColor: COLORS.main2,
    bgColor: COLORS["light-orange"],
  },
};
